export const apiUrl = window.location.protocol === 'http:' 
	? 'http://localhost:5000/adventure-bike-hire-admin/us-central1/api'
    : 'https://us-central1-adventure-bike-hire-admin.cloudfunctions.net/api'
